import React, { useEffect, useRef, useState } from 'react';
import { teamMembers } from '../data/mockData';
import { useLanguage } from '../contexts/LanguageContext';
import '../TeamMarquee.css';

const polishRoles = ['Specjalistka ds. odzyskiwania środków', 'Ekspertka prawna', 'Analityczka finansowa', 'Ekspert ds. kryptowalut', 'Starszy śledczy', 'Specjalista blockchain', 'Ekspert ds. cyberbezpieczeństwa', 'Opiekunka spraw', 'Konsultant ds. odzyskiwania środków', 'Śledczy finansowy'];

const TeamSection = () => {
  const { language } = useLanguage();
  const pl = language === 'pl';
  const viewportRef = useRef(null);
  const [inView, setInView] = useState(false);
  const [pageVisible, setPageVisible] = useState(true);

  useEffect(() => {
    const updateVisibility = () => setPageVisible(!document.hidden);
    updateVisibility();
    document.addEventListener('visibilitychange', updateVisibility);
    const observer = new IntersectionObserver(([entry]) => setInView(entry.isIntersecting), { threshold: 0.08 });
    if (viewportRef.current) observer.observe(viewportRef.current);
    return () => {
      observer.disconnect();
      document.removeEventListener('visibilitychange', updateVisibility);
    };
  }, []);

  const renderMembers = (duplicate = false) => teamMembers.map((member, index) => (
    <li className={`tb-team-member${member.name === 'Robert Legierski' ? ' tb-team-member--robert' : ''}`} key={member.name}>
      <div className="tb-team-portrait">
        <div className="tb-team-portrait-window">
          <img src={member.image} alt={duplicate ? '' : member.name} loading="lazy" width="160" height="160" draggable="false" />
        </div>
      </div>
      <h3>{member.name}</h3>
      <p>{pl ? polishRoles[index] : member.role}</p>
    </li>
  ));

  return (
    <section id="team" className="tb-team tb-home-section" aria-labelledby="tb-team-heading">
      <div className="tb-container">
        <div className="tb-section-heading">
          <h2 id="tb-team-heading">{pl ? 'Ludzie po Twojej stronie.' : 'People on your side.'}</h2>
          <p>{pl ? 'Poznaj zespół TrustBack i obszary, którymi się zajmujemy.' : 'Meet the TrustBack team and the areas we work in.'}</p>
        </div>
        <div
          id="tb-team-marquee"
          className={`tb-team-marquee${!inView || !pageVisible ? ' is-paused' : ''}`}
          ref={viewportRef}
          tabIndex={0}
          role="region"
          aria-label={pl ? 'Zespół TrustBack. Najedź kursorem lub ustaw fokus, aby zatrzymać animację.' : 'TrustBack team. Hover or focus to pause the animation.'}
        >
          <div className="tb-team-marquee-track">
            <ul className="tb-team-marquee-group">{renderMembers()}</ul>
            <ul className="tb-team-marquee-group tb-team-marquee-copy" aria-hidden="true">{renderMembers(true)}</ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
